import providerUtil from './providerUtil';
var getClient = providerUtil.getClient,
    getServerUrlPart = providerUtil.getServerUrlPart,
    getUniqueParamUrlPart = providerUtil.getUniqueParamUrlPart,
    getPageParamUrlPart = providerUtil.getPageParamUrlPart,
    getViewIdUrlPart = providerUtil.getViewIdUrlPart,
    getAdType = providerUtil.getAdType;
var BASE_SAS_URL = 'https://sas.rea.global/';
var PARAMS_BLACKLIST = ['sect', 'tile', 'type', 'dcopt', 'areaprefix', 'channel'];
var AdvertorialSasGlobal = {};

AdvertorialSasGlobal.generateAdLink = function (adSpot) {
  var url = "".concat(BASE_SAS_URL) + "".concat(getClient()) + "".concat(getServerUrlPart(adSpot.config.type)) + "".concat(getViewIdUrlPart(adSpot.viewId)) + "".concat(getPageParamUrlPart(adSpot, PARAMS_BLACKLIST)) + "".concat(getUniqueParamUrlPart(adSpot, PARAMS_BLACKLIST)) + "".concat(getAdType(adSpot.config.type));
  return url;
};

export default AdvertorialSasGlobal;
//# sourceMappingURL=sasGlobalProvider.js.map